export default __webpack_public_path__ + "5ea993733837149ff9cab6ab686f005b.png";